import React, { useState, useEffect, useContext } from 'react';
import { AppContext } from './AppContext';
import { collection, query, where, getDocs, doc, getDoc, limit } from 'firebase/firestore';
import { firestore } from './firebase';
import { debounce } from 'lodash';
import { ProfileComponentFollowing } from './ProfileComponentFollowing';
import { useNavigate } from 'react-router-dom';

const CACHE_DURATION = 5000;

const ProfilesDisplaySearchdat = ({ onProfilePress, onMoveMP }) => {
  const [profiles, setProfiles] = useState([]);
  const [filteredProfiles, setFilteredProfiles] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [viewMode, setViewMode] = useState('horizontal');
  const {
    userId2,
    showMediaPopup, setTrackToView, setExpandedShare, setIsExpanded,
    setIsLoadingArtwork, setIsLoadingProfilePicture, setIsLoadingExpand,
    setIsLoadingNewPopup, setIsExpandedShare, setIsLoadingHideEA,
    setInitiallySelectedItemId, setCurrentlyLoadingProfile, setActiveTab,
    setHideExpandedAlbum, currentUser, setViewingProfile,
    setActivePopupMedia, setCenteredRelease, setArtworkUri,
    setInitialExpandedAlbumAndSong, activePopupMedia, assetsSummary,
    allSingles, allAlbums
  } = useContext(AppContext);

  const navigate = useNavigate();

  const [items, setItems] = useState([]);
  const [isSelecting, setIsSelecting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [lastVisible, setLastVisible] = useState(null);

  const handleProfileSelect = (profile) => {
      const clonedProfile = JSON.parse(JSON.stringify(profile));
      const targetRoute = profile.userId === userId2 ? '/mydat/profile' : `/userprofile/${profile.username}`;
      navigate(targetRoute, { state: { profile: clonedProfile, fromURL: false } });
    };

  useEffect(() => {
    if (isSelecting && activePopupMedia) {
      onProfilePress();
      setIsSelecting(false);
    }
  }, [activePopupMedia]);

  const sortReleasesByTimestamp = (releases) => {
    return [...releases].sort((a, b) => b.releaseTimestamp - a.releaseTimestamp);
  };

  const preparePopupData = (userData) => {
    const albums = sortReleasesByTimestamp(userData.albums || []);
    const singles = sortReleasesByTimestamp(userData.singles || []);
    const videos = sortReleasesByTimestamp(userData.videos || []);

    return {
      artistName: userData.artistName || userData.ArtistName,
      popupProfileImage: userData?.profileImageUrl,
      username: userData.username,
      userId: userData.userId,
      accountType: userData.accountType,
      otherReleases: { albums, singles, videos },
      vocalDrop: userData.vocalDrop,
      voiceDropMuted: userData?.voiceDropMuted,
      bio: userData.bio,
      blurb: userData.blurb,
      location: userData.location,
      timestamp: new Date().getTime(),
      ScreenSKN: userData.ScreenSKN,
    };
  };

  const getCachedUserDoc = async (userId) => {
    const userDocRef = doc(firestore, 'users', userId);
    const userDocSnap = await getDoc(userDocRef);

    if (userDocSnap.exists()) {
      return { ...userDocSnap.data(), userId: userId };
    } else {
      console.error(`No document found in Firestore for userId: ${userId}`);
      return null;
    }
  };

  const fetchItems = async (loadMore = false) => {
    if (searchText.trim() === '') {
      console.log("Clearing items due to empty search.");
      setItems([]);
      setIsLoading(false);
      return;
    }
  
    setIsLoading(true);
    const searchTextLower = searchText.toLowerCase();
    const usernameSearchText = searchTextLower.replace(/\s+/g, ''); // Remove spaces for username search
    const searchTextWithAt = '@' + searchText;
    const searchTextWithAtLower = '@' + searchTextLower;
  
    try {
      // 🔹 Fetch Users from Firestore
      const userQuery = query(
        collection(firestore, 'users'),
        where('username_lower', '>=', searchTextLower),
        where('username_lower', '<=', searchTextLower + '\uf8ff'),
        limit(7)
      );
  
      const userArtistNameQuery = query(
        collection(firestore, 'users'),
        where('ArtistNameLower', '>=', searchTextLower),
        where('ArtistNameLower', '<=', searchTextLower + '\uf8ff'),
        limit(7)
      );
  
      const exactUsernameQuery = query(
        collection(firestore, 'users'),
        where('username_lower', '==', usernameSearchText),
        limit(7)
      );
  
      const results = await Promise.all([
        getDocs(userQuery),
        getDocs(userArtistNameQuery),
        getDocs(exactUsernameQuery)
      ]);
  
      let combinedItems = results.flatMap((snap) =>
        snap.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
          type: 'user'
        }))
      );
  
      let assetsMatches = [];
  
  
      if (assetsSummary) {
  
        assetsSummary.forEach((asset, index) => {
          console.log(
            `🔎 Checking asset ${index + 1}:`,
            `SongName: "${asset.SongName}",`,
            `ArtistNameLower: "${asset.ArtistNameLower}"`
          );
        });
  
        assetsMatches = assetsSummary
          .filter(asset =>
            asset.SongName?.toLowerCase().includes(searchTextLower) ||
            asset.ArtistName?.toLowerCase().includes(searchTextLower)
          )
          .map(asset => ({
            ...asset,
            id: asset.contentId, // Assuming SongURL is unique
            type: 'asset'
          }));
  

      } else {
        console.log("🚨 assetsSummary.assets is missing or not an array.");
      }


      let singlesMatches = [];
      if (allSingles?.length) {
        singlesMatches = allSingles
          .filter(single =>
            single.SongName?.toLowerCase().includes(searchTextLower) ||
            single.ArtistName?.toLowerCase().includes(searchTextLower)
          )
          .map(single => ({
            ...single,
            id: single.contentId,      // SongURL is unique
            type: 'asset'
          }));
      }

      let albumsMatches = [];
      if (allAlbums?.length) {
        albumsMatches = allAlbums
          .filter(album =>
            album.albumName?.toLowerCase().includes(searchTextLower) ||
            album.ArtistName?.toLowerCase().includes(searchTextLower)
          )
          .map(album => ({
            ...album,
            id: album.contentId,     // contentId is unique
            type: 'asset'
          }));
      }

      const normalize = str =>
           (str ?? "")
             .toLowerCase()
             .replace(/[^a-z0-9]/g, "");

      assetsMatches = assetsMatches.map(item => ({ ...item, isFromAssetsSummary: true }));
singlesMatches = singlesMatches.map(item => ({ ...item, isFromAssetsSummary: false }));
albumsMatches  = albumsMatches .map(item => ({ ...item, isFromAssetsSummary: false }));
  
      // 🔹 Deduplicate Items (Users + Assets)
// 🔹 Deduplicate assets by normalized title (SongName or albumName), preferring assetsSummary items
const assetMap = [...assetsMatches, ...singlesMatches, ...albumsMatches].reduce((acc, item) => {
  // pick the right title field
  const rawTitle = item.SongName ?? item.albumName ?? "";
  // normalize (lowercase, strip punctuation & spaces)
  const key = normalize(rawTitle);
  // if unseen, or this one is from assetsSummary (it should override)
  if (!acc[key] || (!acc[key].isFromAssetsSummary && item.isFromAssetsSummary)) {
    acc[key] = item;
  }
  return acc;
}, {});
const dedupAssets = Object.values(assetMap);

      
      // 🔹 Now merge back in your users
      const uniqueItems = Object.values(
        [...combinedItems, ...dedupAssets].reduce((acc, item) => {
          const key = `${item.id}_${item.type}`;   // id + type gives us a unique key
          if (!acc[key]) {
            acc[key] = item;                       // first occurrence wins
          }
          return acc;
        }, {})
      );
  
      console.log("🔄 Unique items after deduplication:", uniqueItems);
  
      // 🔹 Separate Users & Assets
// 🔹 Separate Users & Assets
const users = uniqueItems.filter(item => item.type === 'user');
const assets = uniqueItems.filter(item => item.type === 'asset');

// 🔹 Prioritize Users with Matching Usernames
const prioritizedItems = [];
const otherUsers = [];
let foundMatchingUser = false;

users.forEach(item => {
  if (item.username_lower === usernameSearchText) {
    foundMatchingUser = true;
    prioritizedItems.push(item);
  } else {
    otherUsers.push(item);
  }
});

// 🔹 Split assets into those owned by the matched user and the rest
let userAssetMatches = [];
let otherAssetMatches = [];

if (foundMatchingUser) {
  const matchedUserId = prioritizedItems[0].id;
  userAssetMatches = assets.filter(asset => asset.userId === matchedUserId);
  otherAssetMatches = assets.filter(asset => asset.userId !== matchedUserId);
} else {
  otherAssetMatches = assets;
}

// 🔹 Separate Fan Accounts & Move to the End
const fanAccounts = otherUsers.filter(u => u.accountType === 'Fan');
const nonFanAccounts = otherUsers.filter(u => u.accountType !== 'Fan');

// 🔹 Merge & Finalize Items
const finalItems = foundMatchingUser
  ? [
      ...prioritizedItems,
      ...userAssetMatches,
      ...otherAssetMatches,
      ...nonFanAccounts,
      ...fanAccounts
    ]
  : [
      ...prioritizedItems,
      ...nonFanAccounts,
      ...otherAssetMatches,
      ...fanAccounts
    ];

setItems(finalItems);

    } catch (error) {
      console.error('❌ Error fetching items:', error);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    const debouncedFetch = debounce(() => fetchItems(), 500);

    debouncedFetch();
    return () => debouncedFetch.cancel();
  }, [searchText]);

  const handleSearch = (text) => {
    setSearchText(text);
  };

  const renderItem = ({ item }) => {
    switch (item.type) {
      case 'user':
        return <ProfileComponentFollowing userProfile={item} onPress={() => handleProfileSelect(item)} />;
      case 'song':
      case 'album':
      case 'video':
        return <MediaItem item={item} onPress={handlePressBeginsSongs} type={item.type} />;
        case 'asset':  // ✅ Handle assets properly
        return <MediaItem item={item} onPress={handlePressBeginsSongs} type="song" />;
      default:
        return <div />;
    }
  };

  const handlePressBeginsSongs = async (song) => {
    if (song?.isNFT || song?.editions) {
      const clonedSong = JSON.parse(JSON.stringify(song));
      navigate(`/dat/${song.id}`, { state: { clonedSong } });
    } else {
    const clonedSong = JSON.parse(JSON.stringify(song));
    navigate('/view-song', { state: { song: clonedSong } });
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.title}>Search</div>
      <input
        style={styles.searchInput}
        placeholder="Search..."
        value={searchText}
        onChange={(e) => handleSearch(e.target.value)}
        placeholderTextColor="white"
      />
      <div style={styles.dynamicContentContainer}>
        {isLoading ? (
          <div style={styles.loaderContainer}>Loading...</div>
        ) : (
          <div style={styles.listContainer}>
            {items.map((item) => renderItem({ item }))}
          </div>
        )}
      </div>
    </div>
  );
};

const MediaItem = ({ item, onPress, type }) => {
  const getDisplayName = () => {
    switch (type) {
      case 'album':
        return item.albumName || 'Unknown Album';
      case 'song':
        return item.SongName || item.albumName || 'Unknown Song';
      case 'video':
        return item.VideoName || 'Unknown Video';
      default:
        return 'Unknown';
    }
  };

  return (
    <div onClick={() => onPress(item)} style={styles.itemContainer}>
      <img
        src={item.ArtworkURL}
        alt="Artwork"
        style={styles.songArtwork}
      />
      <div style={styles.textContainer}>
        <p style={styles.artistName}>{item.ArtistName || 'Unknown Artist'}</p>
        <p style={styles.songName}>{getDisplayName()}</p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    flex: 1,

    alignSelf: 'center',
  },
  searchInput: {
    alignSelf: 'center',
    height: '30px',
    width: '93%',
    borderColor: 'rgba(189, 252, 251, 0.3)',
    borderWidth: 1,
    margin: 10,
    borderRadius: 5,
    paddingLeft: 10,
    color: 'white',
    backgroundColor: 'transparent',
    fontFamily: 'brhendrix',
    fontSize: '20px',
    zIndex: 2
  },
  title: {
    alignSelf: 'center',
    fontSize: '20px',
    display: 'flex',
    justifyContent: 'center',
    fontWeight: 'bold',
    marginTop: 20,
    color: 'white',
    fontFamily: 'brhendrix',
  },
dynamicContentContainer: {
  left: '1%',
  width: '100%',
  flex: 1,
  alignSelf: 'center',
  position: 'relative',   // was 'absolute'
  height: '68%',
  marginTop: 12           // add a little spacing under the input
},

  listContainer: {
    paddingHorizontal: 10,
    overflowY: 'scroll',
    height: '100%', // You can adjust this height as needed
  },
  itemContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
    borderRadius: 8,
    overflow: 'hidden',
    cursor: 'pointer',
  },
  songArtwork: {
    width: '100px',
    height: '100px',
    borderRadius: 8,
  },
  textContainer: {
    flex: 1,
    justifyContent: 'center',
    marginLeft: '2%',
  },
  artistName: {
    color: 'white',
    fontSize: '16px',
    marginBottom: '-15px',
    fontWeight: 'bold',
    fontFamily: 'brhendrix',
  },
  songName: {
    color: '#b8b8b8',
    fontSize: '16px',
    fontFamily: 'brhendrix',
  },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};


export { ProfilesDisplaySearchdat };
